import { CrudModel } from "./_crud";

export class TreatmentAppModel extends CrudModel {
	constructor() {
		super("app/treatment");
	}
}

export default new TreatmentAppModel();
